import { Close, Delete, Description, Upload, Visibility } from "@mui/icons-material";
import {
  Alert,
  Avatar,
  Box,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Input,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { CustomButton } from "src/Components/Common/Button/CustomButton";

import { DIALOG_MAX_WIDTHS } from "src/Components/Common/Modal/ModalWidth";
import useFetch from "src/Components/Common/useFetch";
import CustomToast from "src/Components/CustomToast";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";
import { convertUtcToIst } from "src/Utils/DateUtils";
import {
  AttachmentType,
  DocType,
  SummaryStatus,
} from "../../../DisputeResolution/DisputedEntries/constants/disputeEntries";
import { useVendorPortal } from "../../VendorPortalLayout";

const NonReconVpTakeActionDisputedEntries = ({
  selectedRowOfDisputedEntryForModal,
  openTakeActionModal,
  setOpenTakeActionModal,
  listVendorPortalDr,
}) => {
  const [fileInput, setFileInput] = useState<HTMLInputElement | null>(null);
  const [fileInputPod, setFileInputPod] = useState<HTMLInputElement | null>(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [podUploadedFiles, setPodUploadedFiles] = useState([]);

  const { token } = useVendorPortal();

  // Individual form state variables
  const [vendorRemarks, setVendorRemarks] = useState("");
  const [instamartRemarks, setInstamartRemarks] = useState("");
  const [markAsBooked, setMarkAsBooked] = useState(false);
  const [markCancelled, setMarkCancelled] = useState(false);
  const [dependency, setDependency] = useState(selectedRowOfDisputedEntryForModal?.dependency);
  const [action, setAction] = useState(selectedRowOfDisputedEntryForModal?.action);
  const [resolutionStatus, setResolutionStatus] = useState(selectedRowOfDisputedEntryForModal?.resolutionStatus);

  const [attachments, setAttachments] = useState([]);
  const [attachmentsPOD, setAttachmentsPOD] = useState([]);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [poNumber, setPoNumber] = useState(selectedRowOfDisputedEntryForModal?.poNumber || "");
  const [invoiceNumber, setInvoiceNumber] = useState(selectedRowOfDisputedEntryForModal?.invoiceNumber || "");
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  // Additional form fields for different doc types
  const [organisationName, setOrganisationName] = useState(selectedRowOfDisputedEntryForModal?.organizationName || "");
  const [invoiceDate, setInvoiceDate] = useState(
    convertUtcToIst(selectedRowOfDisputedEntryForModal?.invoiceDate, "YYYY-MM-DD") || ""
  );
  const [invoiceAmount, setInvoiceAmount] = useState(selectedRowOfDisputedEntryForModal?.invoiceAmount || "");
  const [debitNoteNumber, setDebitNoteNumber] = useState(selectedRowOfDisputedEntryForModal?.instamartDNNumber || "");
  const [debitNoteDate, setDebitNoteDate] = useState(
    convertUtcToIst(selectedRowOfDisputedEntryForModal?.debitNoteDate, "YYYY-MM-DD") || ""
  );

  const [debitNoteAmount, setDebitNoteAmount] = useState(selectedRowOfDisputedEntryForModal?.dncnAmount || "");
  const [disputedAmount, setDisputedAmount] = useState(selectedRowOfDisputedEntryForModal?.disputedAmount || "");
  const [disputedReason, setDisputedReason] = useState(selectedRowOfDisputedEntryForModal?.disputedReason || "");
  const [actionValueIdForClarificationPending, setActionValueIdForClarificationPending] = useState(null);

  const handleClose = () => {
    setOpenTakeActionModal(false);

    setUploadedFiles([]);
    setMarkAsBooked(false);
    setMarkCancelled(false);
    setVendorRemarks("");
    setInstamartRemarks("");
    setDependency("");
    setResolutionStatus("");
    setAction("");
    setAttachments([]);
    // Reset new form fields
    setOrganisationName("");
    setInvoiceDate("");
    setInvoiceAmount("");
    setDebitNoteNumber("");
    setDebitNoteDate("");
    setDebitNoteAmount("");
    setDisputedAmount("");
    setPoNumber("");
    setInvoiceNumber("");
  };
  const handleCloseConfirmationModal = () => {
    setOpenConfirmationModal(false);
  };

  const handleUpdateClick = () => {
    if (markAsBooked || markCancelled) {
      setOpenConfirmationModal(true);
    } else {
      handleSubmit();
    }
  };

  const handleFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const totalFiles = uploadedFiles.length + selectedFiles.length;

    if (totalFiles > 10) {
      toast.error(<CustomToast message="You can only upload up to 10 files." />);
      event.target.value = ""; // Clear input so same files can be re-selected
      return;
    }

    setUploadedFiles((prev) => [...selectedFiles, ...prev]);
    event.target.value = "";
  };

  const handlePODFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const totalFiles = podUploadedFiles.length + selectedFiles.length;

    if (totalFiles > 10) {
      toast.error(<CustomToast message="You can only upload up to 10 files." />);
      event.target.value = ""; // Clear input so same files can be re-selected
      return;
    }

    setPodUploadedFiles((prev) => [...selectedFiles, ...prev]);
    event.target.value = "";
  };

  const handleDelete = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleDeletePOD = (index) => {
    setPodUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleViewAttachment = (file) => {
    useFetch(API_ENDPOINTS.FETCH_VP_DR_ENTRIES_ACTIONS_ATTACHMENTS_VIEW_NON_RECON.url, "POST", {
      failureMessage: API_ENDPOINTS.FETCH_VP_DR_ENTRIES_ACTIONS_ATTACHMENTS_VIEW_NON_RECON.failureMessage,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          gapId: selectedRowOfDisputedEntryForModal.gapId,
          attachmentId: file.id,
        },
      },
      thenCallBack: (_res) => {
        const link = document.createElement("a");
        link.href = _res.data.data;
        link.target = "_blank";
        link.referrerPolicy = "no-referrer";
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // window.open(_res.data.attachment, "_blank", "noopener,noreferrer");
      },
    });
  };

  // api integration--------------

  useEffect(() => {
    getVpTakeActionDataActionAttachments(selectedRowOfDisputedEntryForModal?.gapId);
    getVpTakeActionDataRemarks(selectedRowOfDisputedEntryForModal?.gapId);
    if (selectedRowOfDisputedEntryForModal?.resolutionStatus === SummaryStatus.ClarificationPending) {
      getActionValueIdForClarificationPending(
        selectedRowOfDisputedEntryForModal?.actionValueId,
        selectedRowOfDisputedEntryForModal?.gapId
      );
    }
  }, []);

  const getVpTakeActionDataActionAttachments = async (gapId) => {
    await useFetch(API_ENDPOINTS.FETCH_VP_DR_ENTRIES_ACTION_ATTACHMENTS_NON_RECON(gapId).url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_VP_DR_ENTRIES_ACTION_ATTACHMENTS_NON_RECON(gapId).failureMessage,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      thenCallBack: (response) => {
        const allAttachments = response.data.data || [];

        // Separate attachments based on AttachmentType
        const podAttachments = allAttachments.filter((attachment) => attachment.attachmentType === AttachmentType.POD);
        const otherAttachments = allAttachments.filter(
          (attachment) => attachment.attachmentType === AttachmentType.Others
        );

        setAttachmentsPOD(podAttachments);
        setAttachments(otherAttachments);
      },
      catchCallBack: () => {},
    });
  };

  const getVpTakeActionDataRemarks = async (gapId) => {
    await useFetch(API_ENDPOINTS.FETCH_VP_DR_ENTRIES_REMARK_NON_RECON(gapId).url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_VP_DR_ENTRIES_REMARK_NON_RECON(gapId).failureMessage,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      thenCallBack: (response) => {
        setVendorRemarks(response.data.data.VendorRemark || "");
        setInstamartRemarks(response.data.data.InstamartRemark || "");
        // setOldValues((prev) => ({ ...prev, vendorRemarks: response.data.VendorRemark || "", instamartRemarks: response.data.InstamartRemark || "" }));
      },
      catchCallBack: () => {},
    });
  };

  const getActionValueIdForClarificationPending = async (id, gapId) => {
    await useFetch(API_ENDPOINTS.FETCH_VP_DR_GET_ACTION_VALUE_ID_FOR_CLARIFICATION_PENDING_NON_RECON().url, "GET", {
      failureMessage:
        API_ENDPOINTS.FETCH_VP_DR_GET_ACTION_VALUE_ID_FOR_CLARIFICATION_PENDING_NON_RECON().failureMessage,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          oldActionValueId: id,
          gapId: gapId,
        },
      },
      thenCallBack: (response) => {
        setActionValueIdForClarificationPending(response.data.actionValueId);
      },
      catchCallBack: () => {},
    });
  };

  const handleSubmit = () => {
    updateTakeActionDataAction(selectedRowOfDisputedEntryForModal?.gapId);
  };

  const updateTakeActionDataAction = async (gapId) => {
    setIsLoadingSubmit(true);
    const bodyFormData = new FormData();

    for (const item of uploadedFiles) {
      bodyFormData.append("Others", item);
    }
    // Add POD files with "POD" attachment type
    for (const item of podUploadedFiles) {
      bodyFormData.append("POD", item);
    }
    bodyFormData.append("newRemark", vendorRemarks || "");
    bodyFormData.append("oldGapIdActionValue", selectedRowOfDisputedEntryForModal?.actionValueId || "");
    bodyFormData.append(
      "newGapIdActionValue",
      uploadedFiles.length > 0 || podUploadedFiles.length > 0
        ? selectedRowOfDisputedEntryForModal?.reviewPendingId
        : markAsBooked
        ? selectedRowOfDisputedEntryForModal?.vendorBookId
        : markCancelled
        ? selectedRowOfDisputedEntryForModal?.vendorCancelId
        : selectedRowOfDisputedEntryForModal?.resolutionStatus === SummaryStatus.ClarificationPending
        ? actionValueIdForClarificationPending
        : ""
    );

    await useFetch(API_ENDPOINTS.UPDATE_VP_DR_ENTRIES_ACTION_NON_RECON(gapId).url, "PUT", {
      failureMessage: API_ENDPOINTS.UPDATE_VP_DR_ENTRIES_ACTION_NON_RECON(gapId).failureMessage,
      showSuccessToast: true,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },

      data: bodyFormData,
      thenCallBack: (_response) => {
        //
        listVendorPortalDr(token, true);
        handleClose();
        setIsLoadingSubmit(false);
      },
      catchCallBack: () => {
        setIsLoadingSubmit(false);
      },
    });
  };

  return (
    <>
      <Dialog open={openTakeActionModal} maxWidth={DIALOG_MAX_WIDTHS.SM} fullWidth>
        <DialogTitle className="dialog-title">
          <div className="heading-m">
            {selectedRowOfDisputedEntryForModal?.docType === DocType.Invoice
              ? "Invoice Missing"
              : selectedRowOfDisputedEntryForModal?.docType === DocType.PRRTV
              ? "PR/RTV Issue"
              : ""}
          </div>
          <div className="vertical_center_align">
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 3 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <>
              {/* Conditional form fields based on doctype */}
              {selectedRowOfDisputedEntryForModal?.docType === DocType.Invoice ? (
                // Invoice fields
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  {/* Organisation Name */}
                  <TextField
                    className="update-custom-border-radius"
                    label="Organisation Name"
                    disabled
                    placeholder="-"
                    variant="outlined"
                    fullWidth
                    value={organisationName}
                    onChange={(e) => setOrganisationName(e.target.value)}
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "40px",
                      },
                    }}
                  />

                  {/* Invoice Number and PO Number */}
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <TextField
                      className="update-custom-border-radius"
                      label="Invoice Number"
                      disabled
                      placeholder="-"
                      variant="outlined"
                      fullWidth
                      value={invoiceNumber}
                      onChange={(e) => setInvoiceNumber(e.target.value)}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                        },
                      }}
                    />
                    <TextField
                      className="update-custom-border-radius"
                      label="Invoice Date"
                      disabled
                      type="date"
                      variant="outlined"
                      fullWidth
                      value={invoiceDate}
                      onChange={(e) => setInvoiceDate(e.target.value)}
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                        },
                      }}
                    />
                  </Box>

                  {/* Invoice Date and Invoice Amount */}
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <TextField
                      className="update-custom-border-radius"
                      label="PO Number"
                      disabled
                      placeholder="-"
                      variant="outlined"
                      fullWidth
                      value={poNumber}
                      onChange={(e) => setPoNumber(e.target.value)}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                        },
                      }}
                    />
                    <TextField
                      className="update-custom-border-radius"
                      label="Invoice Amount"
                      disabled
                      type="number"
                      placeholder="-"
                      variant="outlined"
                      fullWidth
                      value={invoiceAmount}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || /^\d*\.?\d*$/.test(value)) {
                          setInvoiceAmount(value);
                        }
                      }}
                      size="small"
                      inputProps={{
                        min: 0,
                        step: "0.01",
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                        },
                      }}
                    />
                  </Box>
                </Box>
              ) : (
                selectedRowOfDisputedEntryForModal?.docType === DocType.PRRTV && (
                  // PR/RTV fields
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    {/* Organisation Name */}
                    <TextField
                      className="update-custom-border-radius"
                      label="Organisation Name"
                      disabled
                      placeholder="-"
                      variant="outlined"
                      fullWidth
                      value={organisationName}
                      onChange={(e) => setOrganisationName(e.target.value)}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                        },
                      }}
                    />

                    {/* Debit Note Number and Invoice Number */}
                    <Box sx={{ display: "flex", gap: 2 }}>
                      <TextField
                        className="update-custom-border-radius"
                        label="Debit Note Number"
                        disabled
                        placeholder="-"
                        variant="outlined"
                        fullWidth
                        value={debitNoteNumber}
                        onChange={(e) => setDebitNoteNumber(e.target.value)}
                        size="small"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: "40px",
                          },
                        }}
                      />
                      <TextField
                        className="update-custom-border-radius"
                        label="Invoice Number"
                        disabled
                        placeholder="-"
                        variant="outlined"
                        fullWidth
                        value={invoiceNumber}
                        onChange={(e) => setInvoiceNumber(e.target.value)}
                        size="small"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: "40px",
                          },
                        }}
                      />
                    </Box>

                    {/* Debit Note Date and Debit Note Amount */}
                    <Box sx={{ display: "flex", gap: 2 }}>
                      <TextField
                        className="update-custom-border-radius"
                        label="Debit Note Date"
                        disabled
                        type="date"
                        variant="outlined"
                        fullWidth
                        value={debitNoteDate}
                        onChange={(e) => setDebitNoteDate(e.target.value)}
                        size="small"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: "40px",
                          },
                        }}
                      />
                      <TextField
                        className="update-custom-border-radius"
                        label="Debit Note Amount"
                        disabled
                        type="number"
                        placeholder="-"
                        variant="outlined"
                        fullWidth
                        value={debitNoteAmount}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "" || /^\d*\.?\d*$/.test(value)) {
                            setDebitNoteAmount(value);
                          }
                        }}
                        size="small"
                        inputProps={{
                          min: 0,
                          step: "0.01",
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: "40px",
                          },
                        }}
                      />
                    </Box>

                    {/* Disputed Amount */}
                    <TextField
                      className="update-custom-border-radius"
                      label="Disputed Amount"
                      disabled
                      type="number"
                      placeholder="-"
                      variant="outlined"
                      fullWidth
                      value={disputedAmount}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || /^\d*\.?\d*$/.test(value)) {
                          setDisputedAmount(value);
                        }
                      }}
                      size="small"
                      inputProps={{
                        min: 0,
                        step: "0.01",
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                        },
                      }}
                    />

                    <TextField
                      className="update-custom-border-radius"
                      label="Reason of Issue"
                      disabled
                      placeholder="-"
                      variant="outlined"
                      fullWidth
                      value={disputedReason}
                      onChange={(e) => setDisputedReason(e.target.value)}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "40px",
                        },
                      }}
                    />
                  </Box>
                )
              )}
            </>

            {/* Upload POD Document Section */}
            <Card sx={{ border: "1px solid #d6d6d6" }}>
              <CardContent sx={{ padding: "16px 24px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Box>
                    <Typography className="heading-xs">Upload POD*</Typography>

                    <Typography className="body-s-medium" color="textSecondary">
                      Attach your doc file here (supported formats PDF, JPG, PNG). File size limit 50MB.
                    </Typography>
                  </Box>

                  <>
                    <Input
                      type="file"
                      inputRef={(ref) => setFileInputPod(ref)}
                      sx={{ display: "none" }}
                      onChange={handlePODFileUpload}
                      inputProps={{
                        accept: ".pdf,.jpg,.png,.xlsx,.xls",
                        multiple: true,
                      }}
                    />
                    <CustomButton
                      size="small"
                      colorToken="violet"
                      variant="outlined"
                      startIcon={<Upload />}
                      onClick={() => fileInputPod?.click()}
                      disabled={podUploadedFiles.length >= 10}
                    >
                      Upload
                    </CustomButton>
                  </>
                </Box>
              </CardContent>

              {podUploadedFiles.map((file, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 24px",
                    backgroundColor: "#f2f2f2",
                    borderTop: "1px solid #d6d6d6",
                  }}
                >
                  <Chip
                    avatar={
                      <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                        <Description sx={{ fontSize: 14, color: "white" }} />
                      </Avatar>
                    }
                    label={
                      <Box
                        title={file.name}
                        sx={{
                          maxWidth: "250px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {file.name}
                      </Box>
                    }
                    variant="outlined"
                    sx={{
                      maxWidth: "250px",
                      borderColor: "#541c4c",
                      color: "#541c4c",
                      flex: 1,
                    }}
                  />
                  <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                    <CustomButton
                      size="small"
                      color="error"
                      variant="outlined"
                      startIcon={<Delete />}
                      onClick={() => handleDeletePOD(index)}
                    >
                      Delete
                    </CustomButton>
                  </Box>
                </Box>
              ))}

              {attachmentsPOD?.length > 0 &&
                attachmentsPOD?.map((file, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 24px",
                      backgroundColor: "#f2f2f2",
                      borderTop: "1px solid #d6d6d6",
                    }}
                  >
                    <Chip
                      avatar={
                        <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                          <Description sx={{ fontSize: 14, color: "white" }} />
                        </Avatar>
                      }
                      label={
                        <Box
                          title={file.fileName}
                          sx={{
                            maxWidth: "250px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {file.fileName}
                        </Box>
                      }
                      variant="outlined"
                      sx={{
                        maxWidth: "250px",
                        borderColor: "#541c4c",
                        color: "#541c4c",
                        flex: 1, // Allow the chip to take available space
                      }}
                    />
                    <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                      <CustomButton
                        size="small"
                        colorToken="violet"
                        variant="outlined"
                        startIcon={<Visibility />}
                        onClick={() => handleViewAttachment(file)}
                      >
                        View
                      </CustomButton>
                    </Box>
                  </Box>
                ))}
            </Card>

            {/* Upload Document Section */}
            {selectedRowOfDisputedEntryForModal?.docType === DocType.Invoice && (
              <Card sx={{ border: "1px solid #d6d6d6" }}>
                <CardContent sx={{ padding: "16px 24px" }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Box>
                      <Typography className="heading-xs">Upload Invoice Document</Typography>

                      <Typography className="body-s-medium" color="textSecondary">
                        Attach your doc file here (supported formats PDF, JPG, PNG). File size limit 50MB.
                      </Typography>
                    </Box>

                    <>
                      <Input
                        type="file"
                        inputRef={(ref) => setFileInput(ref)}
                        sx={{ display: "none" }}
                        onChange={handleFileUpload}
                        inputProps={{
                          accept: ".pdf,.jpg,.png,.xlsx,.xls",
                          multiple: true,
                        }}
                      />
                      <CustomButton
                        size="small"
                        colorToken="violet"
                        variant="outlined"
                        startIcon={<Upload />}
                        onClick={() => fileInput?.click()}
                        disabled={uploadedFiles.length >= 10}
                      >
                        Upload
                      </CustomButton>
                    </>
                  </Box>
                </CardContent>

                {uploadedFiles.map((file, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 24px",
                      backgroundColor: "#f2f2f2",
                      borderTop: "1px solid #d6d6d6",
                    }}
                  >
                    <Chip
                      avatar={
                        <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                          <Description sx={{ fontSize: 14, color: "white" }} />
                        </Avatar>
                      }
                      label={
                        <Box
                          title={file.name}
                          sx={{
                            maxWidth: "250px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {file.name}
                        </Box>
                      }
                      variant="outlined"
                      sx={{
                        maxWidth: "250px",
                        borderColor: "#541c4c",
                        color: "#541c4c",
                        flex: 1,
                      }}
                    />
                    <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                      <CustomButton
                        size="small"
                        color="error"
                        variant="outlined"
                        startIcon={<Delete />}
                        onClick={() => handleDelete(index)}
                      >
                        Delete
                      </CustomButton>
                    </Box>
                  </Box>
                ))}

                {attachments?.length > 0 &&
                  attachments?.map((file, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "8px 24px",
                        backgroundColor: "#f2f2f2",
                        borderTop: "1px solid #d6d6d6",
                      }}
                    >
                      <Chip
                        avatar={
                          <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                            <Description sx={{ fontSize: 14, color: "white" }} />
                          </Avatar>
                        }
                        label={
                          <Box
                            title={file.fileName}
                            sx={{
                              maxWidth: "250px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {file.fileName}
                          </Box>
                        }
                        variant="outlined"
                        sx={{
                          maxWidth: "250px",
                          borderColor: "#541c4c",
                          color: "#541c4c",
                          flex: 1, // Allow the chip to take available space
                        }}
                      />
                      <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                        <CustomButton
                          size="small"
                          colorToken="violet"
                          variant="outlined"
                          startIcon={<Visibility />}
                          onClick={() => handleViewAttachment(file)}
                        >
                          View
                        </CustomButton>
                      </Box>
                    </Box>
                  ))}
              </Card>
            )}

            {/* Action Form Fields */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {/* Mark as booked and Mark cancelled */}
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {selectedRowOfDisputedEntryForModal?.vendorBookId && (
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography>Mark as Booked</Typography>
                    <Switch
                      checked={markAsBooked}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setMarkAsBooked(true);
                          setMarkCancelled(false);
                        } else {
                          setMarkAsBooked(false);
                        }
                      }}
                      color="primary"
                    />
                  </Box>
                )}

                {selectedRowOfDisputedEntryForModal?.vendorCancelId && (
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography>Mark Cancelled</Typography>
                    <Switch
                      checked={markCancelled}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setMarkCancelled(true);
                          setMarkAsBooked(false);
                        } else {
                          setMarkCancelled(false);
                        }
                      }}
                      color="primary"
                    />
                  </Box>
                )}
              </Box>

              <TextField
                className="update-custom-border-radius"
                label="Action"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={action}
                onChange={(e) => setAction(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled
              />

              <TextField
                className="update-custom-border-radius"
                label="Dependency"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={dependency}
                onChange={(e) => setDependency(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled
              />

              <TextField
                className="update-custom-border-radius"
                label="Resolution Status"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={resolutionStatus}
                onChange={(e) => setResolutionStatus(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled
              />

              <TextField
                className="update-custom-border-radius"
                label="Vendor Remarks"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={vendorRemarks}
                onChange={(e) => setVendorRemarks(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                required={selectedRowOfDisputedEntryForModal?.resolutionStatus === SummaryStatus.ClarificationPending}
              />
              <TextField
                className="update-custom-border-radius"
                label="Instamart Remarks"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={instamartRemarks}
                onChange={(e) => setInstamartRemarks(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions className="dialog-actions">
          <Box sx={{ display: "flex", gap: 1 }}>
            <CustomButton size="medium" colorToken="violet" variant="outlined" onClick={handleClose}>
              Cancel
            </CustomButton>
            <CustomButton
              size="medium"
              colorToken="violet"
              variant="contained"
              disabled={isLoadingSubmit}
              onClick={handleUpdateClick}
            >
              Update
            </CustomButton>
          </Box>
        </DialogActions>
      </Dialog>

      <Dialog open={openConfirmationModal} maxWidth={DIALOG_MAX_WIDTHS.XS} fullWidth>
        <DialogTitle className="dialog-title">
          <div className="heading-m">Are you sure?</div>
          <div className="vertical_center_align">
            <IconButton onClick={handleCloseConfirmationModal}>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 3 }}>
          <Alert severity="info">
            {markAsBooked
              ? "This entry will be moved to subsequently booked. Please make sure you have accounted this entry in your ledger."
              : "This entry will be moved to subsequently cancelled. Please make sure you have cancelled/passed a reversal entry against the disputed entry in your ledger."}
          </Alert>
        </DialogContent>
        <DialogActions className="dialog-actions">
          <CustomButton size="medium" colorToken="violet" variant="outlined" onClick={handleCloseConfirmationModal}>
            Cancel
          </CustomButton>
          <CustomButton
            size="medium"
            colorToken="violet"
            variant="contained"
            //   disabled={uploadedFiles?.length === 0 || isLoadingSubmit}
            //   startIcon={<LoadingIcon loading={isLoadingSubmit} />}
            onClick={handleSubmit}
          >
            Update
          </CustomButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NonReconVpTakeActionDisputedEntries;
